import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ClientRegisterApi } from "../../Services/AddclientsService/AddclioentsApi";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import AlertMessage from "../AlertMessage/AlertMessage";
import { WhiteListEmail } from "../../Services/WhiteListService/WhiteListService";
import CancelBtn from "../CustomButtons/CancelBtn/CancelBtn";

interface AddclientsProps {
  visible: boolean;
  onClose: () => void;

  rowData?: any;

  userid?: string;
  fetchData?: () => void;
}

export const validationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string()
    .required("Phone is required")
    .matches(/^\d{10,15}$/, "Phone number is invalid"),

  address: Yup.string().trim().required("Address is required"),
  additionalEmails: Yup.array().of(Yup.string().email("Invalid email")),
  newEmail: Yup.string().email("Invalid email"),
});

const getRegistrationErrorMessage = (error: unknown): string => {
  if (typeof error === "string" && error.trim()) {
    return error;
  }

  if (error && typeof error === "object") {
    const errorData = error as Record<string, unknown>;
    const response =
      errorData.response && typeof errorData.response === "object"
        ? (errorData.response as Record<string, unknown>)
        : undefined;
    const responseData =
      response?.data && typeof response.data === "object"
        ? (response.data as Record<string, unknown>)
        : undefined;
    const message =
      errorData.message ??
      errorData.Message ??
      responseData?.message ??
      responseData?.Message;

    if (typeof message === "string" && message.trim()) {
      return message;
    }
  }

  return "create client failed, try again";
};

const Addclients: React.FC<AddclientsProps> = ({
  visible,
  onClose,
  rowData,
  fetchData,
}) => {
  const [emailError, setEmailError] = useState("");
  const [user, setuser] = useState("");

  useEffect(() => {
    const userDataString = localStorage.getItem("user");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        setuser(userData.userId);
      } catch (err) {
        console.error("Error parsing user data:", err);
      }
    }
  }, []);

  if (!visible) return null;

  const addEmail = (
    email: string,
    values: any,
    setFieldValue: any,
    setEmailError: React.Dispatch<React.SetStateAction<string>>,
  ) => {
    const trimmed = email.trim();
    if (!trimmed) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmed)) {
      setEmailError("Invalid email");
      return;
    }

    // Check duplicate
    if (values.additionalEmails.includes(trimmed)) {
      setEmailError("Email already added");
      return;
    }

    setFieldValue("additionalEmails", [...values.additionalEmails, trimmed]);
    setFieldValue("newEmail", "");
    setEmailError("");
  };

  console.log("Row Data in Addclients:", rowData);

  // async function submitclientdata(values: {
  //   name: string;
  //   email: string;
  //   phone: string;
  //   address: string;

  //   additionalEmails: string[];
  //   newEmail: string;

  // }) {
  //   try {
  //     const payload = {
  //       name: values.name,
  //       email: values.email,
  //       phoneNumber: values.phone, // map correctly
  //       address: values.address,
  //       adminId: user // TODO: replace with actual adminId from auth context
  //     };
  //     console.log("Submitting client data:", payload);

  //     const response = await ClientRegisterApi(payload);
  //     console.log(" Client registered successfully:", response);
  //      AlertMessage({
  //       text: "Client created successfully",
  //       type: "success",
  //     });

  //     // Close modal on success
  //     onClose();
  //   } catch (error: any) {
  //     console.error(" Error registering client:", error);

  //      AlertMessage({
  //       text: error.message,
  //       type: "error",
  //     });
  //   }
  // }

  async function submitclientdata(values: {
    name: string;
    email: string;
    phone: any;
    address: string;

    additionalEmails: string[];
    newEmail: string;
  }) {
    try {
      const payload = {
        name: values.name.trim(),
        email: values.email,
        phoneNumber: values.phone,
        address: values.address.trim(),
        adminId: user,
      };

      await WhiteListEmail({ email: values.email });
      const response = await ClientRegisterApi(payload);

      AlertMessage({
        text: "Client registration started. Invitation email sent.",
        type: "success",
      });

      // Close modal on success
      onClose();
    } catch (error) {
      console.error(" Error registering client:", error);

      AlertMessage({
        text: getRegistrationErrorMessage(error),
        type: "error",
      });
      throw error;
    }
    finally {
      fetchData && fetchData(); // Refresh data after submission
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "24px",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          width: "600px",
          position: "relative",
        }}
      >
       
         <h2
          style={{
            margin: 0,
            marginBottom: "45px",
            fontSize: "var(--font-size-2xl)",
            fontWeight: 700,
            color: "#111",
          }}
        >
          Create Clients 
        </h2>
        <div
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            cursor: "pointer",
          }}
        >
          <CancelBtn CancelBtnClick={onClose} />
        </div>
        <Formik
          initialValues={{
            name: rowData?.name || "",
            email: rowData?.email || "",
            phone: rowData?.phone || "",
            address: rowData?.companyName || "",
            additionalEmails: rowData?.additionalEmails || [],
            newEmail: "",
          }}
          enableReinitialize //  important for edit mode
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm, setSubmitting }) => {
            try {
              await submitclientdata(values);
              resetForm();
              onClose();
            } catch (error) {
              console.error(error);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {/* Name */}
              <label>
                Name <span className="start">*</span>
              </label>
              <Field
                name="name"
                type="text"
                placeholder="Enter name"
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  borderRadius: "6px",
                }}
              />
              <ErrorMessage
                name="name"
                render={(msg) => (
                  <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>{msg}</div>
                )}
              />

              {/* Email */}
              <label>
                Email <span className="start">*</span>
              </label>
              <Field
                name="email"
                type="email"
                placeholder="Enter email"
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  borderRadius: "6px",
                }}
              />
              <ErrorMessage
                name="email"
                render={(msg) => (
                  <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>{msg}</div>
                )}
              />

              {/* Phone */}
              <label>
                Phone <span className="start">*</span>
              </label>
              <PhoneInput
                country={"us"} // default country
                value={values.phone}
                onChange={(phone: any) => setFieldValue("phone", phone)}
                inputStyle={{
                  width: "100%",
                  borderRadius: "6px",
                  padding: "8px",
                  paddingLeft: "58px",
                  border: "1px solid #ccc",
                }}
                specialLabel=""
              />
              <ErrorMessage
                name="phone"
                render={(msg) => (
                  <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>{msg}</div>
                )}
              />

              {/* Address */}
              <label>
                Address <span className="start">*</span>
              </label>
              <Field
                as="textarea"
                name="address"
                placeholder="Enter address"
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  borderRadius: "6px",
                  width: "100%", // fixed width
                  height: "100px", // fixed height
                  resize: "none", // disable manual resizing
                }}
              />

              <ErrorMessage
                name="address"
                render={(msg) => (
                  <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>{msg}</div>
                )}
              />

              {/* </div> */}
              {emailError && (
                <div style={{ color: "red", fontSize: "var(--font-size-sm)" }}>
                  {emailError}
                </div>
              )}

              {/* New Email Input + Add Button */}
              {/* <div style={{ display: "flex", gap: "8px" }}>
                <Field
                  name="newEmail"
                  type="email"
                  placeholder="Type email and press Enter or click Add"
                  style={{ flex: 1, border: "1px solid #ccc", padding: "8px", borderRadius: "6px" }}
                  onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      addEmail(values.newEmail, values, setFieldValue, setEmailError);
                    }
                  }}
                />
                <button
                  type="button"
                  onClick={() => addEmail(values.newEmail, values, setFieldValue, setEmailError)}
                  disabled={!values.newEmail}
                  style={{
                    backgroundColor: values.newEmail ? "green" : "gray",
                    color: "white",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "none",
                    cursor: values.newEmail ? "pointer" : "not-allowed",
                  }}
                >
                  Add
                </button>
              </div> */}

              {/* Submit + Cancel */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <button
                  type="button"
                  onClick={onClose}
                  style={{
                    flex: 1,
                    backgroundColor: "#7f8081ff",
                    color: "white",
                    padding: "10px",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    flex: 1,
                    backgroundColor: "var(--color-brand)",
                    color: "white",
                    padding: "10px",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {isSubmitting ? "Creating..." : "Create"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Addclients;
